import { render } from "./Communication.vue?vue&type=template&id=4dc109ff"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__